import { useTheme } from '@/components/theme/theme-provider'
import { cn } from '@/lib/utils'
import { Icon } from '@/components/icons/icon'

interface ThemeToggleProps {
  className?: string
}

/** The website's toggle: a square, bordered surface button; moon in light, sun in dark. */
export function ThemeToggle({ className }: ThemeToggleProps) {
  const { resolvedTheme, setTheme } = useTheme()
  const isDark = resolvedTheme === 'dark'
  const label = isDark ? 'Switch to light mode' : 'Switch to dark mode'

  return (
    <button
      type="button"
      aria-label={label}
      title={label}
      onClick={() => setTheme(isDark ? 'light' : 'dark')}
      className={cn(
        'grid size-11 place-items-center rounded-[9px] border border-border bg-card text-muted-foreground transition-colors hover:text-foreground md:size-[38px]',
        className,
      )}
    >
      <Icon name={isDark ? 'sun' : 'moon'} className="size-[17px]" />
    </button>
  )
}
